<template>
  <div class="mainContainer">
    <FirstSection />
    <SecondSection />
    <!-- <ThirdSection /> -->
    <FourthSection />
    <FifthSection />
    <Footer />
  </div>
</template>

<style scoped>
@import "../../assets/css/bla_style.css";
</style>

<script>
import FirstSection from '@/views/public/FirstSection';
import SecondSection from '@/views/public/SecondSection';
// import ThirdSection from '@/views/public/ThirdSection';
import FourthSection from '@/views/public/FourthSection';
import FifthSection from '@/views/public/FifthSection';
import Footer from '@/views/public/partials/Footer';

export default {
  components: {
    Footer,
    FifthSection,
    FourthSection,
    // ThirdSection,
    SecondSection,
    FirstSection
  },
  data: () => ({}),
  method: () => ({}),
  mounted() {
    //Check reaload state in the store
    if (this.$store.getters.reloadSiteState) {
      //Change reloadState to false
      this.$store.commit('setReloadSite', { reloadSite: false });
      //Reload the whole page with plugins and etc...
      location.reload(true);
    }
  }
};
</script>
